module.exports = __webpack_public_path__ + "img/sand-dune-decal-18.002173b3.png";